import React from 'react';
import SamuraiGame from '../SamuraiGame';

const FullTest = () => {
    return <SamuraiGame initialDrillIndex={4} />;
};

export default FullTest;
